export default "__VITE_ASSET__ae2f1e64__"